import { useEffect } from 'react';

const PerformanceMonitor = () => {
  useEffect(() => {
    // Web Vitals monitoring with detailed logging
    if (typeof window !== 'undefined') {
      import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
        getCLS((metric) => {
          console.log('🎯 CLS:', metric.value, metric.value < 0.1 ? '✅ Good' : metric.value < 0.25 ? '⚠️ Needs Improvement' : '❌ Poor');
        });
        
        getFID((metric) => {
          console.log('⚡ FID:', metric.value, metric.value < 100 ? '✅ Good' : metric.value < 300 ? '⚠️ Needs Improvement' : '❌ Poor');
        });
        
        getFCP((metric) => {
          console.log('🎨 FCP:', metric.value, metric.value < 1800 ? '✅ Good' : metric.value < 3000 ? '⚠️ Needs Improvement' : '❌ Poor');
        });
        
        getLCP((metric) => {
          console.log('🖼️ LCP:', metric.value, metric.value < 2500 ? '✅ Good' : metric.value < 4000 ? '⚠️ Needs Improvement' : '❌ Poor');
        });
        
        getTTFB((metric) => {
          console.log('🌐 TTFB:', metric.value, metric.value < 800 ? '✅ Good' : metric.value < 1800 ? '⚠️ Needs Improvement' : '❌ Poor');
        });
      }).catch(() => {
        console.log('Web Vitals library not available');
      });
    }

    // Enhanced Performance Observer
    if ('PerformanceObserver' in window) {
      try {
        // LCP Observer
        const lcpObserver = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            console.log('🎯 LCP Element:', entry.element, 'Time:', entry.startTime);
          }
        });
        lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });

        // Resource timing observer
        const resourceObserver = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (entry.transferSize > 100000) { // 100KB'dan büyük kaynaklar
              console.log('📦 Large Resource:', entry.name, 'Size:', entry.transferSize);
            }
          }
        });
        resourceObserver.observe({ entryTypes: ['resource'] });

        // Layout shift observer
        const clsObserver = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            if (entry.value > 0.1) {
              console.log('📐 Layout Shift:', entry.value, entry.sources);
            }
          }
        });
        clsObserver.observe({ entryTypes: ['layout-shift'] });

      } catch (error) {
        console.log('Performance Observer error:', error);
      }
    }

    // Image loading performance
    const images = document.querySelectorAll('img');
    images.forEach((img, index) => {
      if (!img.complete) {
        const startTime = performance.now();
        img.onload = () => {
          const loadTime = performance.now() - startTime;
          if (loadTime > 1000) {
            console.log(`🖼️ Slow image ${index}:`, img.src, `${loadTime.toFixed(2)}ms`);
          }
        };
      }
    });

  }, []);

  return null;
};

export default PerformanceMonitor;